<div id="validatePrescriberMatch" class="card mt-1">
  <app-validation-header
    [icon]="'groups'"
    [title]="'Validate Prescriber Match'"
    [collapsed]="collapsed"
    (collapseChange)="onCollapseChange($event)"
  />
  <div class="card-body p-1">
    <div>
      <app-validate-prescriber-match-form
        [patientAttachment]="patientAttachment"
        [collapsed]="collapsed"
      />
    </div>
  </div>
</div>
